import React from 'react';
import FadeIn from '../components/ui/FadeIn';
import Button from '../components/ui/Button';

const Services = () => {
  const shootServices = [
    {
      name: "Standard Photoshoot",
      price: "$550",
      time: "90 Minutes",
      desc: "Clean, intentional visuals for your brand or personal use.",
      features: ["15 edited images", "1–2 outfit changes", "Guided direction", "Studio access"],
      link: "https://lbbrandhaus.nuvoro.net/business/lbbrandhaus/service/standard-photoshoot"
    },
    {
      name: "Headshot Session",
      price: "$150",
      time: "30 Minutes",
      desc: "Quick, polished, and professional.",
      features: ["5 edited images", "Simple, clean setup", "Guided posing"],
      link: "https://lbbrandhaus.nuvoro.net/business/lbbrandhaus/service/professional-headshot-session"
    }
  ];

  return (
    <div className="pt-40 pb-40 bg-brand-bone">
      <div className="container mx-auto px-6">
        <FadeIn className="mb-32">
          <h1 className="text-6xl md:text-[8rem] font-heading leading-none mb-8 tracking-tighter">
            Services for <br /><span className="serif-italic text-brand-orange">Forward Motion.</span>
          </h1>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-40">
          {shootServices.map((s, i) => (
            <FadeIn key={i} delay={i * 0.1} className="bg-white p-12 rounded-[2.5rem] shadow-sm border border-brand-teal/5 flex flex-col justify-between">
              <div>
                <div className="flex justify-between items-start mb-8">
                  <h3 className="text-3xl font-heading">{s.name}</h3>
                  <span className="text-2xl font-serif italic text-brand-orange">{s.price}</span>
                </div>
                <p className="text-[10px] font-bold tracking-widest uppercase text-brand-teal/40 mb-6">{s.time}</p>
                <p className="text-lg mb-8 opacity-80">{s.desc}</p>
                <ul className="space-y-3 mb-12">
                  {s.features.map(f => (
                    <li key={f} className="text-sm flex items-center gap-3">
                      <span className="w-1.5 h-1.5 rounded-full bg-brand-orange"></span>
                      {f}
                    </li>
                  ))}
                </ul>
              </div>
              <Button href={s.link} variant="primary" className="w-full">Book Now</Button>
            </FadeIn>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-16 border-t border-brand-teal/10 pt-40">
          <FadeIn>
            <h2 className="text-4xl font-heading mb-6">Content Creation</h2>
            <p className="text-lg opacity-70 mb-10 leading-relaxed">Built for brands that want to show up consistently. Photo & video content, creative direction, and social-ready visuals.</p>
            <Button href="https://forms.gle/nnSDiM9aoCTo1bKp8" variant="outline">Make an Inquiry</Button>
          </FadeIn>
          <FadeIn delay={0.2}>
            <h2 className="text-4xl font-heading mb-6">Brand Strategy</h2>
            <p className="text-lg opacity-70 mb-10 leading-relaxed">Clarity before content. Deep dives into messaging, positioning, and content direction.</p>
            <Button href="https://lbbrandhaus.nuvoro.net/business/lbbrandhaus/service/discovery-call-for-businesses" variant="outline">Book Discovery Call</Button>
          </FadeIn>
        </div>
      </div>
    </div>
  );
};

export default Services;